<template>
  <div>
    <v-row>
      <v-col
        cols="12"
        style="background: linear-gradient(-90deg, #02203d, #001527)"
      >
        <v-container>
          <v-row>
            <v-col
              xs="12"
              sm="12"
              md="6"
              lg="6"
              xl="6"
              class="d-flex align-center"
            >
              <div class="">
                <h1 class="white--text mb-5">
                  Most tech candidates fail before the first interview.
                </h1>
                <p class="white--text">
                  Tech employers get hundreds of applications, and most get
                  filtered out before they ever see them. Check your resume to
                  get through the filters.
                </p>
                <div class="d-flex align-center">
                  <v-btn
                    class="mx-auto mt-3 mb-5"
                    color="primary"
                    to="/evaluate-ai"
                    large
                  >
                    check your resume
                  </v-btn>
                </div>
              </div>
            </v-col>
            <v-col cols="6" class="d-none d-md-block">
              <v-img
                class="mt-10"
                src="../assets/paper_resume_crumbled.png"
                max-height="300"
                contain
                alt="A crumpled resume rejected by a hiring filter"
              >
              </v-img>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
    <v-container>
      <v-row class="text-center mt-10">
        <v-col cols="12">
          <h2 class="mb-5">
            Our users are landing jobs at these awesome companies
          </h2>
          <company-logo-carousel />
        </v-col>
      </v-row>
      <v-row class="text-center mt-10">
        <v-col cols="12" sm="6" md="4" lg="4" xl="4">
          <v-hover v-slot="{ hover }">
            <v-card :elevation="hover ? 5 : 1">
              <v-icon class="mt-5" color="green" x-large>
                mdi-card-multiple-outline
              </v-icon>
              <v-card-title class="d-flex justify-center">
                <div>Multiple review options</div>
              </v-card-title>
              <v-card-text style="height: 100px">
                <div class="d-flex justify-center">
                  Choose one of 3 review options, from basic review to a
                  targeted review for a specific job posting.
                </div>
              </v-card-text>
              <v-card-actions
                class="d-flex justify-center"
                style="height: 50px"
              >
                <v-btn
                  color="primary"
                  plain
                  href="#multiple-review-options"
                  style="z-index: 999"
                  >Learn more</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-hover>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="4" xl="4">
          <v-hover v-slot="{ hover }">
            <v-card :elevation="hover ? 5 : 1">
              <v-icon class="mt-5" color="green" x-large> mdi-graphql </v-icon>
              <v-card-title class="d-flex justify-center">
                <div>Innovative AI analysis</div>
              </v-card-title>
              <v-card-text style="height: 100px">
                <div class="d-flex justify-center mb-2">
                  We use advanced AI algorithms to analyze your resume.
                  Employers use the same techniques to filter candidates
                  resumes, get a headstart by checking yours.
                </div>
              </v-card-text>
              <v-card-actions
                class="d-flex justify-center"
                style="height: 50px"
              >
                <v-btn
                  color="primary"
                  plain
                  href="#ai-analysis"
                  style="z-index: 999"
                  >Learn more</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-hover>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="4" xl="4">
          <v-hover v-slot="{ hover }">
            <v-card :elevation="hover ? 5 : 1" class="ribbon-card">
              <div class="ribbon">Coming soon</div>
              <v-icon class="mt-5" color="green" x-large>
                mdi-account-tie
              </v-icon>
              <v-card-title class="d-flex justify-center">
                <div>Experienced reviewers</div></v-card-title
              >
              <v-card-text style="height: 100px">
                <div class="d-flex justify-center mb-2">
                  We are working to bring real recruiters and hiring managers to
                  review your resume. They will provide feedback from the inside
                  perspective, knowing exactly what recruiters look for in
                  resumes.
                </div>
              </v-card-text>
              <v-card-actions
                class="d-flex justify-center"
                style="height: 50px"
              >
                <v-btn
                  color="primary"
                  plain
                  href="#experienced-reviewers"
                  style="z-index: 999"
                  >Learn more</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-hover>
        </v-col>
      </v-row>
      <v-row class="mt-10">
        <v-col
          cols="12"
          sm="12"
          md="6"
          lg="6"
          xl="6"
          class="d-flex align-center mt-5"
        >
          <div class="" style="width: 100%">
            <h2 class="mb-5 mt-2">
              <a
                name="multiple-review-options"
                class="text-decoration-none black--text"
              >
                Multiple review options
              </a>
            </h2>
            <p class="">
              We offer several different AI review options to suit your needs:
            </p>
            <template>
              <v-expansion-panels multiple>
                <v-expansion-panel class="border-orange">
                  <v-expansion-panel-header class="font-weight-medium">
                    Basic
                    <v-chip
                      color="green"
                      text-color="white"
                      small
                      class="ml-5"
                      style="max-width: 48px"
                      >Free</v-chip
                    >
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <p>
                      Our Basic review provides a quick easy and free way to get
                      feedback on your resume. It checks <b>parsability</b>,
                      <b>formatting</b> and base <b>data checks</b> to ensure
                      your resume can be properly read by automated AI filters,
                      applicant tracking systems and recruiters.
                    </p>
                    <p>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="/review-status-ai?reviewId=101-example"
                        class="text-decoration-none d-flex justify-center"
                      >
                        See example
                      </a>
                    </p>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel class="border-blue">
                  <v-expansion-panel-header class="font-weight-medium">
                    Full
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <p>
                      Our Full review offers a much more detailed analysis of
                      your resume, including <b>career progression</b>, full
                      <b>data checks</b> , <b>certifications and education</b>,
                      <b>job hopping potential</b> and more! This option is
                      ideal for those who want a thorough and comprehensive
                      review of their resume.
                    </p>
                    <p>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="/review-status-ai?reviewId=105-example"
                        class="text-decoration-none d-flex justify-center"
                      >
                        See example
                      </a>
                    </p>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel class="border-purple">
                  <v-expansion-panel-header class="font-weight-medium">
                    Targeted
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <p>
                      Our Targeted review is for those who want to optimize
                      their resume for a <b>specific job posting</b>. It
                      evaluates how well your resume matches the job description
                      and provides tailored feedback to enhance relevance and
                      impact.
                    </p>
                    <p>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="/review-status-ai?reviewId=110-example"
                        class="text-decoration-none d-flex justify-center"
                      >
                        See example
                      </a>
                    </p>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </template>
          </div>
        </v-col>
        <v-col md="6" cols="0" class="d-flex align-center">
          <v-img
            contain
            max-height="300"
            class="pa-10 hidden-sm-and-down"
            src="../assets/3boxes_horizontal_nobg.png"
            alt="Three resume review option tiers: Basic, Full, and Targeted"
          ></v-img>
        </v-col>
      </v-row>
      <v-row class="mt-5">
        <v-col md="6" cols="0" class="d-flex align-center">
          <v-img
            contain
            max-height="300"
            class="pa-10 hidden-sm-and-down"
            src="../assets/ai_diagram.png"
            alt="Diagram showing AI analyzing a resume into scores and charts"
          ></v-img>
        </v-col>
        <v-col cols="12" md="6" lg="6" xl="6" class="d-flex align-center mt-10">
          <div class="">
            <h2 class="mb-5">
              <a name="ai-analysis" class="text-decoration-none black--text">
                Innovative AI analysis
              </a>
            </h2>
            <p class="">
              We are redefining how job candidates present themselves by
              harnessing the power of <b>state-of-the-art LLM models</b> to
              analyze your resume. Our models perform deep, nuanced evaluations
              of resumes, going far beyond traditional keyword matching. By
              understanding context, intent, and industry expectations, our
              system delivers insights that help candidates truly
              <b>stand out</b> in an increasingly competitive job market.
            </p>
            <p class="">
              Most major employers use AI to filter and evaluate incoming
              resumes, check out how your resume performs with the same
              technology.
            </p>
          </div>
        </v-col>
      </v-row>
      <v-row class="mt-5">
        <v-col cols="12" md="6" lg="6" xl="6" class="d-flex align-center mt-10">
          <div class="">
            <h2 class="mb-5">
              <a
                name="experienced-reviewers"
                class="text-decoration-none black--text mr-2"
              >
                Real, experienced reviewers
              </a>
              <v-chip color="#02203d" medium text-color="white"
                >Coming soon!</v-chip
              >
            </h2>
            <p class="">
              All our reviewers are going to be thoroughly <b>vetted</b> and
              <b>verified</b>, ensuring a high standard and quality. Each
              possesses extensive experience in resume reviewing and knows how
              to identify the key elements that make a resume stand out to
              recruiters and hiring managers.
            </p>
            <p>
              Our reviewers will bring a unique advantage: their extensive
              experience reviewing resumes means they can assess your document
              from the
              <b>inside perspective</b>. They will understand the precise
              criteria and filtering methods used by recruiters and hiring
              managers at the companies you're targeting, allowing them to
              optimize your resume to truly stand out.
            </p>
          </div>
        </v-col>
        <v-col md="6" cols="0" class="d-flex align-center">
          <v-img
            contain
            max-height="300"
            class="pa-10 hidden-sm-and-down"
            src="https://as1.ftcdn.net/v2/jpg/01/78/63/30/1000_F_178633029_hAn2tL6yz9RR4K2utyg45bgR9gkxXO54.jpg"
            alt="Team of experienced tech industry reviewers"
          ></v-img>
        </v-col>
      </v-row>

      <v-row class="mt-10">
        <v-col cols="12" class="text-center">
          <h2 class="mb-1">Company-specific resume guides</h2>
          <p>
            Free guides on what recruiters and hiring committees look for at
            each company.
          </p>
        </v-col>
      </v-row>
      <v-row class="text-center mb-4" :class="showAllGuides ? 'mb-10' : ''">
        <v-col
          v-for="guide in visibleGuides"
          :key="guide.path"
          cols="12"
          sm="6"
          md="4"
          lg="4"
          xl="4"
        >
          <v-hover v-slot="{ hover }">
            <v-card :elevation="hover ? 5 : 1" :to="guide.path">
              <v-icon class="mt-5" color="green" x-large>
                {{ guide.icon }}
              </v-icon>
              <v-card-title class="d-flex justify-center">
                <div>{{ guide.title }}</div>
              </v-card-title>
              <v-card-text>
                {{ guide.description }}
              </v-card-text>
            </v-card>
          </v-hover>
        </v-col>
      </v-row>
      <v-row v-if="!showAllGuides" class="mb-10">
        <v-col cols="12" class="text-center">
          <v-btn outlined color="primary" @click="showAllGuides = true">
            Show more guides
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import CompanyLogoCarousel from "./CompanyLogoCarousel.vue";

export default {
  name: "HelloWorld",

  components: { CompanyLogoCarousel },

  data: () => ({
    showAllGuides: false,
    resumeGuides: [
      {
        path: "/faang-resume-guide",
        icon: "mdi-file-document-outline",
        title: "FAANG Resume Guide",
        description:
          "What Meta, Amazon, Apple, Netflix, and Google all look for in a resume.",
      },
      {
        path: "/google-resume-guide",
        icon: "mdi-google",
        title: "Google Resume Guide",
        description:
          "How to write a resume that gets noticed by Google recruiters.",
      },
      {
        path: "/meta-resume-guide",
        icon: "mdi-facebook",
        title: "Meta Resume Guide",
        description:
          "How to stand out for roles at Facebook, Instagram, and WhatsApp.",
      },
      {
        path: "/amazon-resume-guide",
        icon: "mdi-cart-outline",
        title: "Amazon Resume Guide",
        description:
          "How to write a resume that reflects Amazon's Leadership Principles.",
      },
      {
        path: "/tech-startup-resume-guide",
        icon: "mdi-rocket-launch-outline",
        title: "Tech Startup Resume Guide",
        description:
          "How to stand out for startup roles without a big-name employer.",
      },
    ],
  }),
  computed: {
    visibleGuides() {
      return this.showAllGuides
        ? this.resumeGuides
        : this.resumeGuides.slice(0, 3);
    },
  },
  methods: {},
};
</script>

<style scoped>
.border-gray {
  border-left: 10px solid #bdc3c7 !important;
}
.border-orange {
  border-left: 10px solid orange !important;
}
.border-blue {
  border-left: 10px solid blue !important;
}
.border-purple {
  border-left: 10px solid purple !important;
}

.ribbon-card {
  position: relative;
  overflow: hidden;
}
.ribbon {
  position: absolute;
  top: 22px;
  right: -40px;
  background: #02203d;
  color: white;
  padding: 4px 40px;
  transform: rotate(45deg);
  font-size: 12px;
  font-weight: bold;
}
</style>
